import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import audiencesCRUDActions from '@mm/state/actions/AudiencesCRUDActions';

export const useFetchAudienceVariables = () => {
  const activeChatbotId = useSelector(activeChatbotIdSelector);

  const dispatch: Dispatch<StoreState> = useDispatch();

  useEffect(() => {
    if (activeChatbotId) {
      dispatch(audiencesCRUDActions.getAudienceVariable(activeChatbotId));
    }
  }, [activeChatbotId]);
};
